import type { GroupDetail } from "@/types/api";

/**
 * The weekdays a group from `/groups/mine` claims for me: my own car's driving
 * days, or the days of my seat in someone else's (that list holds only seats
 * that count — active or requested). One person never drives and rides, or
 * drives two cars, on the same weekday; the API enforces it, and these are the
 * days the pickers strike through.
 */
export function myDays(group: GroupDetail, userId: string | undefined): number[] {
  return group.driver.id === userId ? group.days : (group.my_membership_days ?? []);
}
